export const TRANSITION_FRAGMENT = `
  precision mediump float;

  #define PI 3.1415926538

  uniform sampler2D tDiffuse;  // rendered scene captured in render target
  uniform float progress;
  uniform float smoothness;
  uniform float scale;
  uniform float seed;

  varying vec2 vUv;

  // --- Noise ---
  float random(vec2 co) {
    highp float a = seed;
    highp float b = 78.233;
    highp float c = 43758.5453;
    highp float dt = dot(co.xy, vec2(a, b));
    highp float sn = mod(dt, 3.14);
    return fract(sin(sn) * c);
  }

  float noise(vec2 st) {
    vec2 i = floor(st);
    vec2 f = fract(st);
    float a = random(i);
    float b = random(i + vec2(1.0, 0.0));
    float c = random(i + vec2(0.0, 1.0));
    float d = random(i + vec2(1.0, 1.0));
    vec2 u = f * f * (3.0 - 2.0 * f);
    return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
  }

  // fBm — 4 octaves for turbulent structure
  float fbm(vec2 p) {
    float val = 0.0;
    float amp = 0.5;
    vec2  freq = p;
    for (int i = 0; i < 4; i++) {
      val  += amp * noise(freq);
      freq *= 2.17;
      amp  *= 0.5;
    }
    return val;
  }
  // --- End Noise ---

  void main() {
    vec4 scene = texture2D(tDiffuse, vUv);

    float n = fbm(vUv * scale + seed * 0.1);

    // Threshold travels from -smoothness to 1+smoothness as progress goes 0→1.
    // At progress=0: all pixels below threshold → dissolve=0 → fully visible.
    // At progress=1: all pixels above threshold → dissolve=1 → fully transparent.
    float p       = mix(-smoothness, 1.0 + smoothness, progress);
    float dissolve = smoothstep(p - smoothness, p + smoothness, n);

    gl_FragColor = vec4(scene.rgb, scene.a * (1.0 - dissolve));
  }
`;
